// Notification.model.ts

import { INotificationType, NotificationType } from "./notification-type.model";

export interface INotification {
  notificationId: string;
  notificationTypeId: string;
  fromHouseFlatId?: string | null;
  toHouseFlatId?: string | null;
  toUidUser?: string | null;
  /* Máximo 45 caracteres en base de datos. */
  title: string;
  /* Máximo 180 caracteres. La API lo llama `subtitle`, no `body`: el nombre se
     respeta aquí para que el modelo no invente un contrato propio. */
  subtitle: string;
  sent: boolean;
  /* Único estado de lectura que existe: no hay `seenAt` ni `readAt`. */
  seen: boolean;
  /* Entidad que originó el aviso. Hoy la consola solo sabe abrir reportes; los
     demás llegan para que el modelo no mienta sobre lo que manda la API. */
  reportId?: string | null;
  visitId?: string | null;
  movementId?: string | null;
  createdAt: string;
  updatedAt: string;
  notificationType?: INotificationType;
}

export class Notification {

  notificationId: string;
  notificationTypeId: string;
  fromHouseFlatId?: string;
  toHouseFlatId?: string;
  toUidUser?: string;
  title: string;
  subtitle: string;
  sent: boolean;
  seen: boolean;
  reportId?: string;
  visitId?: string;
  movementId?: string;
  createdAt: string;
  updatedAt: string;
  notificationType?: NotificationType;

  constructor(
    data: INotification
  ) {
    this.notificationId = data.notificationId;
    this.notificationTypeId = data.notificationTypeId;
    /* La API manda null cuando el aviso no viene de una casa, y mientras el
       backend nuevo no esté desplegado `reportId` ni siquiera viaja. Ambos
       casos se guardan como undefined para tener un solo caso vacío. */
    this.fromHouseFlatId = data.fromHouseFlatId ?? undefined;
    this.toHouseFlatId = data.toHouseFlatId ?? undefined;
    this.toUidUser = data.toUidUser ?? undefined;
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.sent = data.sent;
    this.seen = data.seen;
    this.reportId = data.reportId ?? undefined;
    this.visitId = data.visitId ?? undefined;
    this.movementId = data.movementId ?? undefined;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.notificationType = data.notificationType
      ? new NotificationType(data.notificationType)
      : undefined;
  }

  /* El aviso apunta a un reporte concreto: es el único que hoy tiene a dónde
     llevar al administrador. El resto solo se marcan como vistos. */
  get isReport(): boolean {
    return !!this.reportId;
  }

}
